import { useApiClient } from "../apiClients";
import { SUBJECTS_ENDPOINTS } from "./endpoints";
import type { Subject, SubjectActivation } from "../../models/domain";

export type ListSubjectsParams = {
  program_id: string;
  code?: string;
  limit?: number;
  offset?: number;
  sort?: string;
};

/** `is_active` exclu : le PUT de la matière ne l'écrit pas (voir `setSubjectActivation`). */
export type CreateSubjectPayload = Omit<
  Subject,
  "id" | "created_at" | "updated_at" | "is_active"
>;

export type UpdateSubjectPayload = Partial<CreateSubjectPayload>;

export const useSubjectsApi = () => {
  const apiClient = useApiClient("embed");

  const listSubjects = (params: ListSubjectsParams) =>
    apiClient.get<Subject[]>(SUBJECTS_ENDPOINTS.BASE, { params });

  const getSubject = (subjectId: string) =>
    apiClient.get<Subject>(SUBJECTS_ENDPOINTS.DETAIL(subjectId));

  const createSubject = (payload: CreateSubjectPayload) =>
    apiClient.post<Subject>(SUBJECTS_ENDPOINTS.BASE, payload);

  const updateSubject = (subjectId: string, payload: UpdateSubjectPayload) =>
    apiClient.put<Subject>(SUBJECTS_ENDPOINTS.DETAIL(subjectId), payload);

  const deleteSubject = (subjectId: string) =>
    apiClient.delete<void>(SUBJECTS_ENDPOINTS.DETAIL(subjectId));

  const getSubjectActivation = (subjectId: string) =>
    apiClient.get<SubjectActivation>(SUBJECTS_ENDPOINTS.ACTIVATION(subjectId));

  const setSubjectActivation = (subjectId: string, isActive: boolean) =>
    apiClient.put<SubjectActivation>(SUBJECTS_ENDPOINTS.ACTIVATION(subjectId), { is_active: isActive });

  return {
    listSubjects,
    getSubject,
    createSubject,
    updateSubject,
    deleteSubject,
    getSubjectActivation,
    setSubjectActivation,
  };
};
